export default __webpack_public_path__ + "static/media/video-player.edbc94b4.svg";